// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 200px;
}

.direct-upload-status {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
  color: #555;
  margin-bottom: 8px;
}

.direct-upload-error {
  color: #c62828;
  font-size: 0.85rem;
  margin-bottom: 8px;
}

.attachment-host {
  width: 100%;
}

mat-dialog-content {
  min-width: 600px;
  min-height: 200px;
  padding: 2px 24px !important;
  background-color: #fff;
}

.content {
  padding: 16px;
  border-radius: 4px;
}

.attachment-section-title {
  font-size: 18px;
  font-weight: 600;
  color: #0b2d71;
}

.button-gap {
  gap: 12px;
}

.wa-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.wa-dialog {
  min-width: 600px;
  max-width: 94vw;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  overflow: hidden;
}

.wa-dialog [mat-dialog-title] {
  background-color: #fff;
  margin: 0 !important;
  padding: 5px 24px !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: 700;
}

.wa-dialog mat-dialog-actions {
  background-color: #fff;
  padding: 8px 24px !important;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.row-item {
  border: 1px solid #d3d3d3;
  padding: 12px;
  border-radius: 4px;
}

.field-label {
  display: block;
  margin-bottom: 6px;
  font-weight: 600;
}

.form-control {
  width: 100%;
  margin-bottom: 10px;
}

.hidden-file-input {
  display: none;
}

.field-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
}

.field-value {
  flex: 1;
}

.upload-drop-zone {
  border: 2px dashed #cfd8dc;
  border-radius: 6px;
  background: #fafbfc;
  min-height: 90px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.upload-drop-zone.drag-over {
  border-color: #0b2d71;
  background: #eef3ff;
}

/* Loading Container */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  padding: 2rem;
}

.loading-container p {
  color: #0b2d71;
  font-size: 1.1rem;
  font-weight: bold;
}

.direct-upload-status {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
  color: #555;
  margin-bottom: 8px;
}

.direct-upload-error {
  color: #c62828;
  font-size: 0.85rem;
  margin-bottom: 8px;
}

.attachment-host {
  width: 100%;
}

mat-dialog-content {
  min-width: 1100px;
  min-height: 200px;
  padding: 12px !important;
  background-color: #f0f0f0;
}

.content {
  padding: 16px;
  border-radius: 4px;
}

.attachment-section-title {
  font-size: 18px;
  font-weight: 600;
  color: #0b2d71;
}

/* Table Styles */
.table {
  background-color: white;
}

.table-header th {
  background-color: #0b5c9f;
  color: white;
  font-weight: 600;
  padding: 12px;
  border: none;
}

.table tbody td {
  padding: 12px;
  vertical-align: middle;
}

.table tbody tr {
  border-bottom: 1px solid #dee2e6;
}

/* Action Buttons */
.btn-action-open {
  background-color: #0b5c9f;
  color: white;
  padding: 6px 12px;
  margin-right: 12px;
  border: none;
  display: inline-block;
}

.btn-action-open:hover {
  background-color: #094a7f;
}

.btn-action-edit {
  background-color: #0b5c9f;
  color: white;
  padding: 6px 12px;
  margin-right: 12px;
  border: none;
  display: inline-block;
}

.btn-action-edit:hover {
  background-color: #094a7f;
}

.btn-action-delete {
  background-color: #c62828;
  color: white;
  padding: 6px 12px;
  border: none;
  display: inline-block;
}

.btn-action-delete:hover {
  background-color: #a02020;
}

.arrow {
  margin-left: 4px;
}

.button-gap {
  gap: 12px;
}

/* Dialog Actions */
mat-dialog-actions {
  background-color: #f0f0f0;
  padding: 12px !important;
}

/* Overlay styles for edit/upload popups */
.wa-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}

.wa-dialog {
  min-width: 600px;
  max-width: 94vw;
  background: #f0f0f0;
  border-radius: 4px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);
  overflow: hidden;
}

.wa-dialog [mat-dialog-title] {
  background-color: #f0f0f0;
  margin: 0 !important;
  padding: 4px 12px !important;
  display: flex !important;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
}

.wa-dialog mat-dialog-content {
  padding: 12px !important;
}

.wa-dialog mat-dialog-content .content {
  background-color: #f0f0f0;
  box-shadow: none;
}

.wa-dialog mat-dialog-actions {
  background-color: #f0f0f0;
  padding: 4px 12px !important;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.row-item {
  border: 1px solid #d3d3d3;
  padding: 12px;
  border-radius: 4px;
  background-color: #fff;
}

.field-label {
  display: block;
  margin-bottom: 6px;
  font-weight: 600;
}

.form-control {
  width: 100%;
  margin-bottom: 10px;
}

.hidden-file-input {
  display: none;
}

.field-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;
}

.field-value {
  flex: 1;
}

.field-error {
  color: #dc3545;
  font-size: 0.75rem;
  margin-top: 2px;
}

.upload-drop-zone {
  border: 2px dashed #cfd8dc;
  border-radius: 6px;
  background: #fafbfc;
  min-height: 90px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.upload-drop-zone.drag-over {
  border-color: #0b2d71;
  background: #eef3ff;
}
`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/project-details/spacer-details/spacer-test-attachments-dialog/spacer-test-attachments-dialog.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,4BAA4B;EAC5B,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,8DAA8D;AAChE;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,oBAAoB;EACpB,4BAA4B;EAC5B,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,8DAA8D;AAChE;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB","sourcesContent":[".loading-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 200px;\n}\n\n.direct-upload-status {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.85rem;\n  color: #555;\n  margin-bottom: 8px;\n}\n\n.direct-upload-error {\n  color: #c62828;\n  font-size: 0.85rem;\n  margin-bottom: 8px;\n}\n\n.attachment-host {\n  width: 100%;\n}\n\nmat-dialog-content {\n  min-width: 600px;\n  min-height: 200px;\n  padding: 2px 24px !important;\n  background-color: #fff;\n}\n\n.content {\n  padding: 16px;\n  border-radius: 4px;\n}\n\n.attachment-section-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #0b2d71;\n}\n\n.button-gap {\n  gap: 12px;\n}\n\n.wa-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.35);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1050;\n}\n\n.wa-dialog {\n  min-width: 600px;\n  max-width: 94vw;\n  background: #fff;\n  border-radius: 4px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);\n  overflow: hidden;\n}\n\n.wa-dialog [mat-dialog-title] {\n  background-color: #fff;\n  margin: 0 !important;\n  padding: 5px 24px !important;\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.5rem;\n  font-weight: 700;\n}\n\n.wa-dialog mat-dialog-actions {\n  background-color: #fff;\n  padding: 8px 24px !important;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.row-item {\n  border: 1px solid #d3d3d3;\n  padding: 12px;\n  border-radius: 4px;\n}\n\n.field-label {\n  display: block;\n  margin-bottom: 6px;\n  font-weight: 600;\n}\n\n.form-control {\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.hidden-file-input {\n  display: none;\n}\n\n.field-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.field-value {\n  flex: 1;\n}\n\n.upload-drop-zone {\n  border: 2px dashed #cfd8dc;\n  border-radius: 6px;\n  background: #fafbfc;\n  min-height: 90px;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  transition: border-color 0.2s ease, background-color 0.2s ease;\n}\n\n.upload-drop-zone.drag-over {\n  border-color: #0b2d71;\n  background: #eef3ff;\n}\n\n/* Loading Container */\n.loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 300px;\n  padding: 2rem;\n}\n\n.loading-container p {\n  color: #0b2d71;\n  font-size: 1.1rem;\n  font-weight: bold;\n}\n\n.direct-upload-status {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 0.85rem;\n  color: #555;\n  margin-bottom: 8px;\n}\n\n.direct-upload-error {\n  color: #c62828;\n  font-size: 0.85rem;\n  margin-bottom: 8px;\n}\n\n.attachment-host {\n  width: 100%;\n}\n\nmat-dialog-content {\n  min-width: 1100px;\n  min-height: 200px;\n  padding: 12px !important;\n  background-color: #f0f0f0;\n}\n\n.content {\n  padding: 16px;\n  border-radius: 4px;\n}\n\n.attachment-section-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: #0b2d71;\n}\n\n/* Table Styles */\n.table {\n  background-color: white;\n}\n\n.table-header th {\n  background-color: #0b5c9f;\n  color: white;\n  font-weight: 600;\n  padding: 12px;\n  border: none;\n}\n\n.table tbody td {\n  padding: 12px;\n  vertical-align: middle;\n}\n\n.table tbody tr {\n  border-bottom: 1px solid #dee2e6;\n}\n\n/* Action Buttons */\n.btn-action-open {\n  background-color: #0b5c9f;\n  color: white;\n  padding: 6px 12px;\n  margin-right: 12px;\n  border: none;\n  display: inline-block;\n}\n\n.btn-action-open:hover {\n  background-color: #094a7f;\n}\n\n.btn-action-edit {\n  background-color: #0b5c9f;\n  color: white;\n  padding: 6px 12px;\n  margin-right: 12px;\n  border: none;\n  display: inline-block;\n}\n\n.btn-action-edit:hover {\n  background-color: #094a7f;\n}\n\n.btn-action-delete {\n  background-color: #c62828;\n  color: white;\n  padding: 6px 12px;\n  border: none;\n  display: inline-block;\n}\n\n.btn-action-delete:hover {\n  background-color: #a02020;\n}\n\n.arrow {\n  margin-left: 4px;\n}\n\n.button-gap {\n  gap: 12px;\n}\n\n/* Dialog Actions */\nmat-dialog-actions {\n  background-color: #f0f0f0;\n  padding: 12px !important;\n}\n\n/* Overlay styles for edit/upload popups */\n.wa-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.35);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1050;\n}\n\n.wa-dialog {\n  min-width: 600px;\n  max-width: 94vw;\n  background: #f0f0f0;\n  border-radius: 4px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.25);\n  overflow: hidden;\n}\n\n.wa-dialog [mat-dialog-title] {\n  background-color: #f0f0f0;\n  margin: 0 !important;\n  padding: 4px 12px !important;\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.25rem;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.87);\n}\n\n.wa-dialog mat-dialog-content {\n  padding: 12px !important;\n}\n\n.wa-dialog mat-dialog-content .content {\n  background-color: #f0f0f0;\n  box-shadow: none;\n}\n\n.wa-dialog mat-dialog-actions {\n  background-color: #f0f0f0;\n  padding: 4px 12px !important;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.row-item {\n  border: 1px solid #d3d3d3;\n  padding: 12px;\n  border-radius: 4px;\n  background-color: #fff;\n}\n\n.field-label {\n  display: block;\n  margin-bottom: 6px;\n  font-weight: 600;\n}\n\n.form-control {\n  width: 100%;\n  margin-bottom: 10px;\n}\n\n.hidden-file-input {\n  display: none;\n}\n\n.field-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.field-value {\n  flex: 1;\n}\n\n.field-error {\n  color: #dc3545;\n  font-size: 0.75rem;\n  margin-top: 2px;\n}\n\n.upload-drop-zone {\n  border: 2px dashed #cfd8dc;\n  border-radius: 6px;\n  background: #fafbfc;\n  min-height: 90px;\n  padding: 12px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  transition: border-color 0.2s ease, background-color 0.2s ease;\n}\n\n.upload-drop-zone.drag-over {\n  border-color: #0b2d71;\n  background: #eef3ff;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
